module.exports = __webpack_public_path__ + "img/ck-mutil-ani-star-icon.2017807a.png";